import { render } from "./partner-money.vue?vue&type=template&id=622aad94"
import script from "./partner-money.vue?vue&type=script&lang=js"
export * from "./partner-money.vue?vue&type=script&lang=js"

import exportComponent from "/home/Work/max/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__